import React from 'react'

import { BaseIconProps, IconSizes, IconColors } from '../base'

const Retry: React.FC<BaseIconProps> = React.forwardRef(
  ({ className, size = 'md', color = 'default' }, ref) => (
    <svg
      ref={ref}
      className={className}
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 1.498V8.498H15.5"
        stroke={IconColors[color]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4999 8.5C18.7434 3.33338 11.5281 2.15292 6.32092 5.853C3.31708 7.99938 1.5254 11.4566 1.50362 15.1484C1.48184 18.8402 3.23262 22.3183 6.21092 24.5"
        stroke={IconColors[color]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
)

export default Retry
